import React, { useEffect, useState } from 'react'
import './App.scss'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import LandingContent from './components/landing-content/landing-content.component'
import SSO from './pages/sso/sso.page'
import Logout from './pages/logout/logout.page'
import HomePage from './pages/homepage/homepage.page'
import EvalPage from './pages/eval-page/eval-page.page'
import AdminPage from './pages/admin/admin.page'
import UnderConstruction from './pages/under-construction/under-construction.page'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentUser, setDbData, setUserProfile } from './state/slices/userSlice'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/utils/firebase.utils';
import { screenSizes } from './utils/responsiveQueries'
import { setScreenSize } from './state/slices/listsSlice'
import CpduPrintable from './components/HOME/cpdu-printable/cpdu-printable.component'
import PageNotFound from './pages/page-not-found/page-not-found.component'

import ReactGA from "react-ga4";
import CpduPrintableV2 from './components/HOME/cpdu-printable/cpdu-printable-v2.component'
const gaTrackingID = "G-TX4JKB7YVY"

function Root() {
  
  const currentUser = useSelector(state => state.userData.currentUser);
  const dispatch = useDispatch(); 
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // navigate('/construction');
    // return;

    // console.log('loading', loading)
    getScreenSize();

    onresize = (event) => {
        getScreenSize();
    };

    ReactGA.initialize(gaTrackingID);
      // if (!window.location.host.includes('localhost:')) {
          ReactGA.send({
              hitType: 'pageview',
              page: window.location.pathname,
              title: document.title 
          })
      // }

    onAuthStateChanged(auth, (user) => {
      console.log('user: ', user)
      console.log('currentUser:', currentUser)
      if (user) {
        const newUser = {
          displayName: user.displayName,
          email: user.email,
          metadata: {
            createdAt: Number(user.metadata.createdAt),
            lastLogInAt: user.metadata.lastLogInAt
          },
          uid: user.uid,
          photoURL: user.photoURL
        }
        dispatch(setCurrentUser({...newUser}));
      } else {
        // let href = window.location.origin
    	// 	// console.log(window.location)
		//     let encoded = encodeURIComponent(href  + `/sso/?token={token}&intendedurl=%2F`)
		//     // console.log(encoded)
		//     window.open(`https://eweb.ilprincipals.org/eweb/?Site=ipa&WebCode=LoginRequired&expires=yes&URL_success=${encoded}`, '_self')
        // navigate('logout')
        // console.log(window.location.pathname)
        if (!window.location.pathname === '/') {
            window.open('https://google.com', '_self')
        }
        dispatch(setCurrentUser(null))
        dispatch(setUserProfile(null))
        dispatch(setDbData(null))
      }
    })
    const links = document.querySelectorAll("[data-part1][data-part2][data-part3]");
		for (const link of links) {
			const attrs = link.dataset;
            link.setAttribute(
                "href",
                `mailto:${attrs.part1}@${attrs.part2}.${attrs.part3}?subject=${attrs.subject}`
            );
            link.textContent = `${attrs.part1}@${attrs.part2}.${attrs.part3}`;
        }
  }, [])

  // useEffect(() => {
  //   if (location.pathname === '/construction') return;
  //   navigate('/construction');
  //   return;
  // }, [location])

  function getScreenSize() {
      let sizeArr = screenSizes.filter(s => 
        window.innerWidth >= s.minWidth && 
        window.innerWidth <= s.maxWidth
      );
      let size;
      if (!sizeArr || !sizeArr.length) {
          size = 'desktop'
      } else {
          size = sizeArr[0].name;
      }
      dispatch(setScreenSize(size));
  }

  return (
    <div className="App">
      <Routes>
            <Route path='/' element={<LandingContent />} ></Route>
            <Route path='/:evalPath' element={<LandingContent />} ></Route>
            <Route path='/sso' element={<SSO />}></Route>
            <Route path='/logout' element={<Logout />}></Route>
            {/* <Route element={<AuthWrapper />}> */}
                <Route path='/home/*' element={<HomePage />}></Route>
                <Route path='/eval/*' element={<EvalPage />}></Route>
                <Route path='/admin/*' element={<AdminPage />}></Route>
                <Route path='/print/:urlData' element={<CpduPrintableV2 />}></Route>
            {/* </Route> */}
            <Route path='/construction' element={<UnderConstruction />}></Route>
            <Route path='/404' element={<PageNotFound />}></Route>
            <Route path="*" element={<Navigate replace to="/404" />} />
            <Route path="/noaccess" element={<Navigate replace to="/404" />} />
      </Routes>
    </div>
  )
}

export default Root
